import React from 'react';
import PropTypes from 'prop-types';
import { useResponsiveSettings } from "@seims/shared";
import { List, ConfigProvider } from 'antd';
import './GenericCardList.css';

export const GenericCardList = ({ 
  dataSource, 
  renderItem,
  isLoading=false,
  pagination = {}
}) => {
  const { pageSize, pageItemSizeSM } = useResponsiveSettings();

  return (
    <ConfigProvider
      theme={{
        components: {
          Pagination: {
            borderRadius: 0,
            itemSizeSM: pageItemSizeSM // Default is 24px
          },
        },
      }}
    >
        <List
        // header={"Venue Options"}
        loading={isLoading}
        grid={{ 
            gutter: 16,
            xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 3
        }}
        locale={{ emptyText: <></> }}
        pagination={{
            className: "bordered-pagination",
            pageSize,
            align: "end",
            hideOnSinglePage: true,
            showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} results`,
            showSizeChanger: false,
            showLessItems: true,
            size: "small",
            ...pagination
        }}
        dataSource={dataSource}
        renderItem={renderItem}
        />
    </ConfigProvider>
  );
};

GenericCardList.propTypes = {
  dataSource: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  pagination: PropTypes.object,
};
